import React, { useState } from 'react'
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material'
import { useStyles } from './styles'
import ModalCreditCard from '../ModalCreditCard/ModalCreditCard'
import { useSelector } from 'react-redux'

const CreditCardInfo = ({ cardInfo, setSelectedCC, disabledCheck }) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.down('md'))

  const [isOpenModal, setIsOpenModal] = useState(false)
  const [learnMoreInfo, setLearnMoreInfo] = useState({})
  const { selectedCC } = useSelector((state) => state.availableCreditCard)

  const handleOnChange = (position, e) => {
    if (e.target.checked) setSelectedCC((initState) => [...initState, position])

    if (!e.target.checked)
      setSelectedCC((oldValues) => {
        return oldValues.filter((checked) => checked !== position)
      })
  }

  return (
    <>
      <Card className={classes.card}>
        <CardContent className={isMobile ? classes.cardContentMobile : classes.cardContent}>
          {/* Title section always appears first */}
          <Typography variant="h5" className={classes.cardTitle}>
            {cardInfo.title}
          </Typography>
          
          {/* Card image appears right after title in mobile view */}
          {isMobile && (
            <Box className={classes.cardImageContainerMobile}>
              <img 
                src={cardInfo.cardImage} 
                alt="" 
                className={classes.cardImage} 
              />
            </Box>
          )}
          
          <Box className={classes.contentContainer}>
            {/* Content that comes after the image in mobile view */}
            <ul className={classes.bulletList}>
              {cardInfo.bulletPoints.map((points) => (
                <li key={points.id}>
                  <Typography variant="body2">{points.text}</Typography>
                </li>
              ))}
            </ul>
            <Box component="hr" className={classes.divider} />
            {cardInfo.benefits.map((benefit) => (
              <Box key={benefit.id} className={classes.benefitItem}>
                <img src={benefit.icon} alt="" />
                <Typography variant="body2" color="#868686">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: benefit.text
                    }}
                  />
                </Typography>
              </Box>
            ))}
            <Box className={classes.actionContainer}>
              <Button
                variant="contained"
                className={classes.learnMoreBtn}
                disabled={cardInfo.disabled}
                onClick={() => {
                  setLearnMoreInfo({
                    ...cardInfo,
                    cardType: cardInfo.cardType,
                    segment: cardInfo.segment,
                    id: cardInfo.id
                  })
                  setIsOpenModal(true)
                }}
              >
                Learn more +
              </Button>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={disabledCheck}
                    onChange={(e) => handleOnChange(cardInfo.id, e)}
                    value={cardInfo.id}
                    checked={selectedCC.includes(cardInfo.id)}
                  />
                }
                label='Add to compare'
              />
            </Box>
          </Box>
          
          {/* In desktop view, the image appears on the right side */}
          {!isMobile && (
            <Box className={classes.cardImageContainer}>
              <img 
                src={cardInfo.cardImage} 
                alt="" 
                className={classes.cardImage} 
              />
            </Box>
          )}
        </CardContent>
      </Card>

      <ModalCreditCard
        isOpen={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        modalInfo={learnMoreInfo}
        setOpenModal={setIsOpenModal}
      />
    </>
  )
}

export default CreditCardInfo
